export default __webpack_public_path__ + "static/media/CHESS.43d2e362.svg";